import React, { useState, useRef, useEffect } from 'react';

export default function VideoWithLoader({ mp4Src, webmSrc, className }) {
    const [isLoading, setIsLoading] = useState(true);
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleLoadedData = () => setIsLoading(false);
        const handleError = () => {
            setIsLoading(false);
            console.error('Video failed to load');
        };

        video.addEventListener('loadeddata', handleLoadedData);
        video.addEventListener('error', handleError);

        return () => {
            video.removeEventListener('loadeddata', handleLoadedData);
            video.removeEventListener('error', handleError);
        };
    }, [mp4Src, webmSrc]);

    return (
        <div className="video-container">
            {isLoading && (
                <div className="video-loader">
                    <div className="loader-spinner"></div>
                    <p>Загрузка видео...</p>
                </div>
            )}
            <video
                ref={videoRef}
                autoPlay
                loop
                muted
                playsInline
                className={className}
                preload="metadata"
                onError={(e) => console.error('Video failed to load:', e.target.error)}
            >
                {mp4Src && <source src={mp4Src} type="video/mp4" />}
                {webmSrc && <source src={webmSrc} type="video/webm" />}
                Ваш браузер не поддерживает видео.
            </video>
        </div>
    );
}